import axios from 'axios';
import { postDataOptions } from '../../services/backendServices';
import { BASE_URL } from '../../services/environments';

// Api's
const PAYMENT_ORDER_API = 'api/payment/order';
const PAYMENT_STATUS_API = 'api/payment/status';

// Services
export const paymentOrderService = async (payload) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, PAYMENT_ORDER_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const paymentStatusService = async (payload) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, PAYMENT_STATUS_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
